import { Subscribable } from 'ply-config/subscribable'
import { Deferred } from 'ply-utils/Deferred'

type Status = 'idle' | 'loading' | 'loaded' | 'error'

export class Loader extends Subscribable {
	private URL: string
	private baseURL: string
	private status: Status = 'idle'
	private deferred = new Deferred<void>()
	private maxRetries: number
	private retryDelay: number

	constructor({ URL = '/config2', baseURL, maxRetries = 6, retryDelay = 200 }) {
		super()
		this.baseURL = baseURL
		this.URL = URL
		this.maxRetries = maxRetries
		this.retryDelay = retryDelay
	}

	load = async () => {
		if (this.status !== 'idle') {
			return
		}

		this.status = 'loading'

		for (let attempt = 0; attempt < this.maxRetries; attempt++) {
			try {
				const raw = await this.loadRaw()

				setTimeout(() => {
					this.status = 'loaded'
					this.deferred.resolve()
					this.publish('load', null)
				}, 0)

				return raw
			} catch (e) {
				if (attempt < this.maxRetries - 1) {
					await delay(this.retryDelay)
				} else {
					this.status = 'error'
					this.deferred.reject(e)
				}
			}
		}
	}

	on = (event: 'load', callback: () => void) => {
		this.subscribe(event, callback)
	}

	public get state() {
		return {
			status: this.status,
			promise: this.deferred.promise,
		}
	}

	private async loadRaw() {
		const res = await globalThis.fetch(`${this.baseURL || ''}${this.URL}`, {
			method: 'GET',
			credentials: 'include',
			mode: 'cors',
			redirect: 'follow',
		})

		if (!res.ok) {
			throw new Error('Failed to load')
		}

		return await res.json()
	}
}

const delay = (ms: number) => {
	return new Promise((resolve) => setTimeout(resolve, ms))
}
